import React, { forwardRef } from 'react';
import Label from '../label';
import TextArea from '../text-area';
import {
  ComponentSize,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';

interface LabelTextAreaProps {
  label: string;
  variant?: ComponentVariant;
  size?: ComponentSize;
  className?: string;
  labelProps?: React.ComponentProps<typeof Label>;
  inputProps?: React.ComponentProps<typeof TextArea>;
  labelPosition?: 'side' | 'top';
}

const LabelTextArea = forwardRef<HTMLTextAreaElement, LabelTextAreaProps>(
  (
    {
      label,
      variant = 'primary',
      size = 'md',
      className = '',
      labelProps = {},
      inputProps = {},
      labelPosition = 'side',
    },
    ref
  ) => {
    const containerClasses = {
      side: 'flex-col sm:flex-row sm:items-start justify-between',
      top: 'flex-col relative',
    };

    const labelClasses = {
      top: [
        'absolute -top-[0.6rem] left-3 z-10',
        'px-0.5',
        'bg-gradient-to-b from-white via-white to-transparent',
        'pb-1',
      ].join(' '),
      side: '',
    };

    const topLabelSize: ComponentSize = ['xs', 'sm'].includes(size)
      ? '2xs'
      : 'xs';
    const labelSize = labelPosition === 'top' ? topLabelSize : size;

    return (
      <div
        className={`flex ${containerClasses[labelPosition]} ${
          labelPosition === 'top' ? '' : 'gap-2'
        } ${className}`}
      >
        <div className={labelPosition === 'side' ? 'sm:w-1/3' : ''}>
          <Label
            {...labelProps}
            variant={variant}
            size={labelSize}
            className={`${labelClasses[labelPosition]} ${labelProps.className || ''}`}
          >
            {label}
          </Label>
        </div>
        <div className="flex-1">
          <TextArea ref={ref} variant={variant} size={size} {...inputProps} />
        </div>
      </div>
    );
  }
);

LabelTextArea.displayName = 'LabelTextArea';

export default LabelTextArea;
